export default "__VITE_ASSET__795727b4__$_?component__"